module.exports = __webpack_public_path__ + "img/03.48da0f19.png";